export * from './lib/components/customer-input/customer-input.component';
export * from './lib/components/customer-detail/customer-detail.component';
export * from './lib/components/customer-query.component';
export * from './lib/kundenabfrage.routes';
export * from './lib/kundenabfrage.providers';
export * from './lib/kundenabfrage.shared';
